import { ChangeDetectionStrategy, Component, inject, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-video-viewer-modal",
  imports: [],
  templateUrl: "./video-viewer-modal.component.html",
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VideoViewerModalComponent {
    readonly activeModal = inject(NgbActiveModal);

    @Input() url!: string;

}
